// extracted by mini-css-extract-plugin
export default {"root":"NotFoundScreen_root__io0CZ","title":"NotFoundScreen_title__c6c-3","link":"NotFoundScreen_link__8ab5z"};